import React, { useEffect, useState } from "react";
import axios from "axios";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Modal from 'react-modal';

import Navbar from "../../Components/Navbar";

const BoutiquePage = (props) => {
    const token = localStorage.getItem("JWT");

    const [allStuff, setAllStuff] = useState([]);       // rendu des images globales
    const [statut, setStatut] = useState(1);            // state pour les filtres avatar/cartes....
    const [modalIsOpen, setIsOpen] = useState(false);         //gestion de la modal
    const [userWarbond, setUserWarbond] = useState("");         //Affichage du porte monaie utilisateur
    const [userUec, setUserUec] = useState("");         //Affichage du porte monaie utilisateur

    // affichage des info modal
    const [imageModal, setImageModal] = useState("");
    const [titreModal, setTitreModal] = useState("");
    const [descriptionModal, setDescriptionModal] = useState("");
    const [prixModal, setPrixModal] = useState("");
    const [rareteModal, setRareteModal] = useState("");
    const [dispoModal, setDispoModal] = useState(true);

    const [selectedOption, setSelectedOption] = useState("");       // filtres par rareté
    const [selectedGettingOption, setSelectedGettingOption] = useState("");     //filtre par methode d'obtention
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredItems, setFilteredItems] = useState([]);
    const [userStuffOn, setUserStuffOn] = useState(false);
    const [userStuff, setUserStuff] = useState([]);
    const [itemName, setItemname] = useState("cartes");

    const userId = localStorage.getItem("userId");

    const customStyles = {      // gestion du style de la modal
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: "80%",
            height: "80%",
            backgroundColor: "rgba(18, 18, 18, 0.35)",
            padding: "15px",
            border: "none",
        },
    };

    const mediaQueryStyles = {
        '@media (min-width: 1025px) and (max-width: 1440px)': {
            content: {
                width: "90%",
                height: "60%",
            },
        },
        '@media (min-width: 1921px) and (max-width: 2560px)': {
            content: {
                width: "80%",
                height: "70%",
            },
        },
        '@media (min-width: 2561px) and (max-width: 3440px)': {
            content: {
                width: "60%",
                height: "70%",
            },
        },
    };

    //-----------------------------------------------------Gestion de la modal---------------------------------------------------------//

    function openModal(e) {         // ouverture de la modale 
        let focusThingID = e.target.id
        localStorage.setItem("thingsId", focusThingID)

        const updatedStyles = { ...customStyles };

        if (window.matchMedia('(min-width: 1025px) and (max-width: 1440px)').matches) {
            updatedStyles.content = {
                ...customStyles.content,
                ...mediaQueryStyles['@media (min-width: 1025px) and (max-width: 1440px)'].content,
            };
        }
        if (window.matchMedia('(min-width: 1921px) and (max-width: 2560px)').matches) {
            updatedStyles.content = {
                ...customStyles.content,
                ...mediaQueryStyles['@media (min-width: 1921px) and (max-width: 2560px)'].content,
            };
        }
        if (window.matchMedia('(min-width: 2561px) and (max-width: 3440px)').matches) {
            updatedStyles.content = {
                ...customStyles.content,
                ...mediaQueryStyles['@media (min-width: 2561px) and (max-width: 3440px)'].content,
            };
        }
        setModalStyles(updatedStyles);

        switch (statut) {
            case 1:
                setIsOpen(true);
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/carte/${focusThingID}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setImageModal(res.data.lien)
                        setTitreModal(res.data.nom)
                        setDescriptionModal(res.data.description)
                        setPrixModal(res.data.prix)
                        setRareteModal(res.data.rareté)
                        setDispoModal(res.data.disponible)
                    })
                    .catch((err) => {
                        console.log("err:", err);
                    });
                break;

            case 2:
                setIsOpen(true);
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/avatar/${focusThingID}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setImageModal(res.data.lien)
                        setTitreModal(res.data.nom)
                        setDescriptionModal(res.data.description)
                        setPrixModal(res.data.prix)
                        setRareteModal(res.data.rareté)
                        setDispoModal(res.data.disponible)

                    })
                    .catch((err) => {
                        console.log("err:", err);
                    });

                break;
            case 3:
                setIsOpen(true);
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/cadre/${focusThingID}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setImageModal(res.data.lien)
                        setTitreModal(res.data.nom)
                        setDescriptionModal(res.data.description)
                        setPrixModal(res.data.prix)
                        setRareteModal(res.data.rareté)
                        setDispoModal(res.data.disponible)

                    })
                    .catch((err) => {
                        console.log("err:", err);
                    });

                break;
            case 4:
                focusThingID = e.target.firstChild.id
                localStorage.setItem("thingsId", focusThingID)
                buy()

                break;
            default:
                break;
        }
    }

    function closeModal() {         // fermeture de la modal
        setIsOpen(false);
    }

    const [modalStyles, setModalStyles] = React.useState(customStyles);

    //-----------------------------------------------------Get all data---------------------------------------------------------//

    function getOneUser() {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/auth/userInventory/${userId}`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                switch (statut) {
                    case 1:
                        setUserStuff(res.data.cartes);
                        break;

                    case 2:
                        setUserStuff(res.data.avatars);
                        break;

                    case 3:
                        setUserStuff(res.data.cadres);
                        break;
                    default:
                        break;
                }
                setUserWarbond(res.data.warbonds)
                setUserUec(res.data.UEC)
            })
            .catch((err) => {
                console.log("err:", err);
            });
    }

    function getCartes() {  // recupère les cartes

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allcartes`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                // Filtrer les cartes disponibles
                const availableCards = res.data.filter(card => card.disponible === true);
                // Mettre à jour l'état avec les cartes disponibles
                setAllStuff(availableCards);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function getAvatars() {  // recupère les avatars

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allAvatars`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                  // Filtrer les cartes disponibles
                  const availableAvatars = res.data.filter(avatar => avatar.disponible === true);
                  // Mettre à jour l'état avec les cartes disponibles
                  setAllStuff(availableAvatars);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function getCadres() {   // recupère les avatars

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allCadres`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                     // Filtrer les cartes disponibles
                     const availableCadres = res.data.filter(cadre => cadre.disponible === true);
                     // Mettre à jour l'état avec les cartes disponibles
                     setAllStuff(availableCadres);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function getWarbonds() {  // recupère les warbonds

        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}api/allWarbonds`,
            headers: {
                Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
            }
        })
            .then((res) => {
                setAllStuff(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    //-----------------------------------------------------shop actions---------------------------------------------------------//

    function buy(e) {  //Acheter une carte
        confirmAlert({
            title: "Confirmer votre achat!",
            message: "Etes vous sûr?",
            buttons: [
                {
                    label: "Oui",
                    onClick: () => {
                        const userId = localStorage.getItem("userId");
                        let thingsIdbuy = localStorage.getItem("thingsId")

                        switch (statut) {
                            case 1:
                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/buyCarte`,
                                    headers: {
                                        Authorization: `Bearer ${token}`
                                    },
                                    data: {
                                        userId,
                                        carteId: thingsIdbuy,
                                    },
                                })
                                    .then((res) => {
                                        toast.success("Carte acheté avec succès!");
                                        let response = res.data.message;
                                        let responseStatut = 1;
                                        sendLogMessage(response, responseStatut);
                                        getOneUser();
                                        setIsOpen(false);
                                    })
                                    .catch((err) => {
                                        switch (err.response.status) {
                                            case 401:
                                                toast.error("Vous êtes trop pauvre!");
                                                break;
                                            case 400:
                                                toast.error("Vous possédez deja cette carte!");
                                                break;
                                            default:
                                                break;
                                        }
                                        let response = err.response.data.message;
                                        let responseStatut = 0;
                                        sendLogMessage(response, responseStatut);
                                    });

                                break;

                            case 2:
                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/buyAvatar`,
                                    headers: {
                                        Authorization: `Bearer ${token}`
                                    },
                                    data: {
                                        userId,
                                        avatarId: thingsIdbuy,
                                    },
                                })
                                    .then((res) => {
                                        toast.success("Avatar acheté avec succès!");
                                        let response = res.data.message;
                                        let responseStatut = 1;
                                        sendLogMessage(response, responseStatut);
                                        getOneUser();
                                        setIsOpen(false);
                                    })
                                    .catch((err) => {
                                        switch (err.response.status) {
                                            case 401:
                                                toast.error("Vous êtes trop pauvre!");
                                                break;
                                            case 400:
                                                toast.error("Vous possédez deja cet avatar!");
                                                break;
                                            default:
                                                break;
                                        }
                                    });

                                break;
                            case 3:
                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/buyCadre`,
                                    headers: {
                                        Authorization: `Bearer ${token}`
                                    },
                                    data: {
                                        userId,
                                        cadreId: thingsIdbuy,
                                    },
                                })
                                    .then((res) => {
                                        toast.success("Cadre acheté avec succès!");
                                        let response = res.data.message;
                                        let responseStatut = 1;
                                        sendLogMessage(response, responseStatut);
                                        getOneUser();
                                        setIsOpen(false);
                                    })
                                    .catch((err) => {
                                        switch (err.response.status) {
                                            case 401:
                                                toast.error("Vous êtes trop pauvre!");
                                                break;
                                            case 400:
                                                toast.error("Vous possédez deja ce cadre!");
                                                break;
                                            default:
                                                break;
                                        }
                                    });

                                break;
                            case 4:
                                axios({
                                    method: "post",
                                    url: `${process.env.REACT_APP_API_URL}api/buyWarbonds`,
                                    headers: {
                                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                                    },
                                    data: {
                                        userId,
                                        warbondsId: thingsIdbuy,
                                    },
                                })
                                    .then((res) => {
                                        toast.success("Warbonds pack acheté avec succès!");
                                        let response = res.data.message;
                                        let responseStatut = 1;
                                        sendLogMessage(response, responseStatut);
                                        getOneUser();
                                    })
                                    .catch((err) => {
                                        switch (err.response.status) {
                                            case 401:
                                                toast.error("Vous êtes trop pauvre!");
                                                break;
                                            case 400:
                                                toast.error("Erreur Backend!");
                                                break;
                                            default:
                                                break;
                                        }
                                    });
                                break;
                            default:
                                break;
                        }
                    },
                },
                {
                    label: "Non",
                    onClick: () => {
                        // Code à exécuter si l'utilisateur clique sur "Non"
                    },
                },
            ],
        });
    }

    function filtres(e) {  // filtre menu

        let focusButton = e.target
        let focusTitle = focusButton.firstChild

        let focusCartesButton = document.getElementById("cartes")
        focusCartesButton.classList.remove("onclickButton")
        focusCartesButton.firstChild.classList.remove("onclickButton")

        let focusCadresButton = document.getElementById("cadres")
        focusCadresButton.classList.remove("onclickButton")
        focusCadresButton.firstChild.classList.remove("onclickButton")

        let focusAvatarsButton = document.getElementById("avatars")
        focusAvatarsButton.classList.remove("onclickButton")
        focusAvatarsButton.firstChild.classList.remove("onclickButton")

        let focusWarbondsButton = document.getElementById("warbonds")
        focusWarbondsButton.classList.remove("onclickButton")
        focusWarbondsButton.firstChild.classList.remove("onclickButton")

        switch (e.target.id) {
            case "cartes":
                focusTitle.classList.add("onclickButton");
                focusButton.classList.add("onclickButton");
                getCartes();
                setStatut(1);
                setItemname("cartes");
                resetSearchInputs();
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/auth/userInventory/${userId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setUserStuff(res.data.cartes);
                    })
                    .catch((err) => {
                        console.log("err:", err);
                    });

                break;

            case "avatars":
                focusTitle.classList.add("onclickButton");
                focusButton.classList.add("onclickButton");
                getAvatars();
                setStatut(2);
                setItemname("avatars");
                resetSearchInputs();
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/auth/userInventory/${userId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setUserStuff(res.data.avatars);
                    })
                    .catch((err) => {
                        console.log("err:", err);
                    });

                break;

            case "cadres":
                focusTitle.classList.add("onclickButton");
                focusButton.classList.add("onclickButton");
                getCadres();
                setStatut(3);
                setItemname("cadres");
                resetSearchInputs();
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}api/auth/userInventory/${userId}`,
                    headers: {
                        Authorization: `Bearer ${token}` // Ajouter le token JWT dans les en-têtes de la requête
                    }
                })
                    .then((res) => {
                        setUserStuff(res.data.cadres);
                    })
                    .catch((err) => {
                        console.log("err:", err);
                    });

                break;

            case "warbonds":
                focusTitle.classList.add("onclickButton");
                focusButton.classList.add("onclickButton");
                getWarbonds();
                setStatut(4);
                resetSearchInputs();
                break;

            default:
                break;
        }
    }

    function sendLogMessage(response, responseStatut) {
        axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}api/addLog`,
            data: {
                logMessage: response,
                logType: "Boutique",
                logStatut: responseStatut,
            },
        })
            .then((res) => { })
            .catch((err) => { });
    }

    useEffect(() => {
        getCartes();
        getOneUser();

        let focusCartesButton = document.getElementById("cartes")
        focusCartesButton.classList.add("onclickButton");
        focusCartesButton.firstChild.classList.add("onclickButton");
    }, []);

    useEffect(() => {    // gestion du style des cartes

        switch (statut) {
            case 1:
                let focus1 = document.querySelectorAll(
                    ".boutique__galerie__images__card"
                );
                focus1.forEach((element) => {
                    element.style.backgroundColor = "transparent";
                    element.firstChild.style.objectFit = "cover";
                });
                break;
            case 2:
                let focus2 = document.querySelectorAll(
                    ".boutique__galerie__images__card"
                );
                focus2.forEach((element) => {
                    element.style.backgroundColor = "rgba(18, 18, 18, 0.35)";
                    element.firstChild.style.objectFit = "contain";
                });
                break;
            case 3:
                let focus3 = document.querySelectorAll(
                    ".boutique__galerie__images__card"
                );
                focus3.forEach((element) => {
                    element.style.backgroundColor = "transparent";
                    element.firstChild.style.objectFit = "cover";
                });
                break;
            case 4:
                let focus4 = document.querySelectorAll(".boutique__galerie__images__card");
                focus4.forEach((element) => {
                    element.style.backgroundColor = "rgba(18, 18, 18, 0.35)";
                });

                let focusBottom = document.querySelectorAll(".boutique__galerie__images__card__info__bot");
                focusBottom.forEach((element) => {
                    element.style.background = "transparent";
                });
                break;
            default:
                break;
        }
    }, [filteredItems]);



    const rareteFiltre = (event) => {       //filtre par rareté
        setSelectedOption(event.target.value);
    };

    const possessionFiltre = () => {        //affichage des posséssions
        setUserStuffOn(!userStuffOn);
    };

    const obtentionFiltre = (event) => {        //filtre par methode d'obtention
        setSelectedGettingOption(event.target.value);
    };

    const handleInputChange = (event) => {      //barre de recherche
        setSearchTerm(event.target.value);
    };

    const filterItems = () => {     //rendu suivant les filtres 
        let filteredItems = allStuff;

        // Filtrer par terme de recherche
        if (searchTerm) {
            filteredItems = filteredItems.filter((item) =>
                item.nom.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        // Filtrer par option sélectionnée
        if (selectedOption) {
            filteredItems = filteredItems.filter(
                (item) => item.rareté === selectedOption
            );
        }

        // Filtrer par la manière de d'obtenir l'item
        if (selectedGettingOption) {
            filteredItems = filteredItems.filter(
                (item) => item.aquisition === selectedGettingOption
            );
        }
        // Vérifie si l'ID de l'élément est présent dans userStuff
        if (!userStuffOn) {
            filteredItems = filteredItems.filter((item) => {
                return !userStuff.find((userItem) => userItem.id === item.id);
            });
        }
        return filteredItems;
    };

    const resetSearchInputs = () => {       // reset de tout les filtres de recherche
        setSelectedOption("");
        setSelectedGettingOption("");
        setSearchTerm("");
        setUserStuffOn(false);
    };

    useEffect(() => {
        setFilteredItems(filterItems());
    },
        [selectedOption, searchTerm, selectedGettingOption, userStuffOn, allStuff, userStuff, userWarbond]);

    return (
        <div className="boutiquePage">
            <Navbar />
            <ToastContainer
                position="bottom-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="dark"
            />
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={modalStyles}
                contentLabel="modal boutique"
                ariaHideApp={false}
            >
                <div className='modalBoutique'>
                    <div className='modalBoutique__image'>
                        <img src={imageModal} alt="image de l'objet selectioné" />
                    </div>
                    <div className='modalBoutique__info'>
                        <h2>{titreModal}</h2>
                        <div className='modalBoutique__info__bottom'>
                            <p className='modalBoutique__info__bottom__description'>{descriptionModal}</p>


                            <div className="modalBoutique__info__bottom__prix">
                                <p>Rareté: {rareteModal}</p>

                                <span>
                                    <p>{prixModal.toLocaleString("fr-FR")} </p>
                                    <img className="moneyLogo" src="images/warbond.png" alt="logo Warbond" />
                                </span>
                            </div>


                        </div>
                        <div className='modalBoutique__acheter'>
                            {dispoModal ? <button onClick={buy}>Acheter</button> : <h3>Indisponible a l'achat</h3>}

                        </div>

                    </div>


                </div>

            </Modal>
            <div className="boutiqueCont">
                <div className="boutique">

                    <div className="boutique__bandeau">
                        <div className="boutique__bandeau__menu">

                            <button onClick={filtres} id="cartes" className="cartes"><p>Cartes</p></button>
                            <button onClick={filtres} id="avatars" className="avatars"><p>Avatars</p></button>
                            <button onClick={filtres} id="cadres" className="cadres"><p>Cadres</p></button>
                            <button onClick={filtres} id="warbonds" className="warbonds"><p>Warbonds</p></button>

                        </div>
                    </div>

                    <div className="boutique__filtres" >
                        {statut !== 4 &&
                            <div className="boutique__filtres__optionContainer" >
                                <div className="boutique__filtres__option">

                                    <input type="text" placeholder="Rechercher..." value={searchTerm} onChange={handleInputChange} />

                                    <select value={selectedOption} onChange={rareteFiltre} >
                                        <option value="">Sélectionnez une rareté</option>
                                        <option value="Commune">Commune</option>
                                        <option value="Rare">Rare</option>
                                        <option value="Epic">Epic</option>
                                        <option value="Légendaire">Légendaire</option>
                                    </select>

                                    <select value={selectedGettingOption} onChange={obtentionFiltre} >
                                        <option value="">Méthode d'obtention</option>
                                        <option value="Boutique">Boutique</option>
                                        <option value="Event">Event</option>
                                        <option value="Tournoi">Tournoi</option>
                                        <option value="Gratuit">Gratuit</option>
                                    </select>
                                </div>

                                <div className="boutique__filtres__possession">
                                    Afficher les {itemName} que vous possédez
                                    <input className="boutique__filtres__possession__checkbox" type="checkbox" checked={userStuffOn} onChange={possessionFiltre} />
                                </div>
                            </div>

                        }
                        <div className="boutique__filtres__warbonds">
                            <p>{userWarbond.toLocaleString("fr-FR")}</p>
                            <img className="moneyLogo" src="images/warbond.png" alt="logo Warbond" />
                        </div>

                        {statut === 4 &&

                            <div className="boutique__filtres__warbonds">
                                <p>{userUec.toLocaleString("fr-FR")}</p>

                                <img className="moneyLogo" src="images/uec.png" alt="logo Warbond" />
                            </div>

                        }

                    </div>

                    <div className="boutique__galerie">

                        <div className="boutique__galerie__images">
                            {filteredItems.map((cartes) => (
                                <div key={cartes.id} onClick={openModal} className="boutique__galerie__images__card">
                                    {statut !== 4 ?
                                        <img key={cartes.id} id={cartes.id} src={cartes.lien} alt="images de la boutique" />
                                        :
                                        <p id={cartes.id} className="warbondsValeur">  {cartes && cartes.valeur !== undefined ? cartes.valeur.toLocaleString("fr-FR") : ''}</p>
                                    }

                                    <div className="boutique__galerie__images__card__info">
                                        <div className="boutique__galerie__images__card__info__top">
                                        </div>

                                        <div className="boutique__galerie__images__card__info__bot">

                                            <div className="boutique__galerie__images__card__info__bot__left">
                                                <h4>{cartes.nom}</h4>
                                                <p>{cartes.rareté}</p>
                                            </div>

                                            <div className="boutique__galerie__images__card__info__bot__right">
                                                {statut !== 4 ?
                                                    <p> <img className="shopMoneyLogo" src="images/warbond.png" alt="logo Warbond" />{cartes.prix.toLocaleString("fr-FR")}</p>
                                                    :
                                                    <p>{cartes.prix.toLocaleString("fr-FR")} aUEC</p>
                                                }
                                                <p>{cartes.aquisition}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default BoutiquePage;
